// Labels aligned with users.models.MyUser.UserRole (ADMIN=1 … MAINTENANCE=5).
// Role 4 is MINE_USER — not a generic "user"; use "Kaivoskäyttäjä" in Finnish UI.

export const USER_ROLE_LABELS = {
  1: 'Admin',
  2: 'YTM-käyttäjä',
  3: 'Korjaaja',
  4: 'Kaivoskäyttäjä',
  5: 'Huolto',
};

export function getUserRoleLabel(roleId) {
  if (roleId == null || roleId === '') return '';
  const id = Number(roleId);
  return USER_ROLE_LABELS[id] || 'Käyttäjä';
}
